// Mock data for the real estate website

// Platform-level metadata (previously per-agent). Kept as a placeholder so components
// can still reference `agentInfo` while we finish the pivot to a lead-based portal.
export const agentInfo = {
  name: "Vendetucasa.ar",
  title: "Portal Inmobiliario",
  degree: "",
  company: "Vendetucasa.ar",
  officeAddress: "Buenos Aires, Argentina",
  phone: "",
  whatsapp: "",
  email: "contacto@vendetucasa.ar",
  photo: "",
  bio: "Vendetucasa.ar es un portal independiente de análisis inmobiliario. Agregamos oferta actualizada del mercado, calculamos valores por barrio con datos reales y detectamos oportunidades y unidades en pozo para compradores e inversores en CABA y Zona Norte.",
  experience: "",
  satisfactionRate: ""
};

export const services = [
  {
    id: 1,
    title: "Análisis del valor de propiedad",
    description: "Calculá el precio estimado de tu casa o departamento con datos reales de mercado por barrio.",
    icon: "clipboard-check"
  },
  {
    id: 2,
    title: "Buscador de oportunidades",
    description: "Detectamos propiedades cuyo precio/m² está 30% o más por debajo del promedio de su barrio.",
    icon: "trending-up"
  },
  {
    id: 3,
    title: "Propiedades en pozo",
    description: "Filtro exclusivo para unidades en construcción o preventa con año de entrega detectado automáticamente.",
    icon: "home"
  },
  {
    id: 4,
    title: "Guía de barrios",
    description: "Datos de precios, servicios, transporte y seguridad para 67 barrios de CABA y Zona Norte.",
    icon: "search"
  },
  {
    id: 5,
    title: "Mapa interactivo",
    description: "Visualizá todas las propiedades en un mapa con precios y filtros combinados.",
    icon: "map"
  },
  {
    id: 6,
    title: "Alertas de oportunidades",
    description: "Recibí un aviso por email cuando aparezcan propiedades que coincidan con tu búsqueda.",
    icon: "bell"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "María G.",
    property: "Buscó en Palermo",
    text: "Muy útil para comparar precios reales entre barrios. El filtro de oportunidades me ayudó a acortar la búsqueda un montón.",
    rating: 5
  },
  {
    id: 2,
    name: "Carlos F.",
    property: "Interesado en pozo",
    text: "Encontré un desarrollo en Belgrano que ninguna otra plataforma me estaba mostrando. La info de año de entrega fue clave.",
    rating: 5
  },
  {
    id: 3,
    name: "Laura M.",
    property: "Usó la calculadora",
    text: "La calculadora dinámica es un golazo. Me dio una referencia clara del precio antes de reunirme con la inmobiliaria.",
    rating: 5
  }
];

export const recentSales = [
  {
    id: 1,
    type: "Departamento",
    location: "Palermo",
    size: "85m²",
    price: "USD 185,000",
    image: "https://images.unsplash.com/photo-1721790491712-118597223de1?w=600&q=80"
  },
  {
    id: 2,
    type: "Casa",
    location: "Belgrano",
    size: "240m²",
    price: "USD 420,000",
    image: "https://images.unsplash.com/photo-1760067538022-8ef8739b1b18?w=600&q=80"
  },
  {
    id: 3,
    type: "Loft",
    location: "Puerto Madero",
    size: "120m²",
    price: "USD 280,000",
    image: "https://images.unsplash.com/photo-1759264244827-1dde5bee00a5?w=600&q=80"
  }
];

// Articles will be fetched from API
export const sampleArticles = [
  {
    id: "sample1",
    title: "Tendencias del Mercado Inmobiliario 2026",
    excerpt: "Descubre las principales tendencias que marcarán el mercado inmobiliario este año.",
    content: "El mercado inmobiliario continúa evolucionando...",
    image_url: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80",
    created_at: new Date().toISOString()
  }
];